<template>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow">

            <v-row justify="center">
                <h3 class="text-center">ASIGNACIÓN RESPONSABLE ZONA DE ADSCRIPCIÓN </h3><br>
                <h3 class="text-center">CUATRIMESTRE : {{ dato_cuatrimestre.no_cuatrimestre }} DEL AÑO {{ dato_cuatrimestre.anio }}</h3><br>
                <h4 class="text-center">FECHA INICIO EVALUACIÓN : <b>{{ dato_cuatrimestre.fecha_inicio_captura }}</b> - FECHA FIN EVALUACIÓN <b>{{ dato_cuatrimestre.fecha_fin_captura }}</b></h4><br>
                  <br>
            </v-row>

            <br>

            <v-row justify="center">
                <v-row v-if="mostrar_tabla_zona">
                    <v-col v-if="showTable" cols="12" sm="12">
                        <v-client-table :data="zonas_adscripcion" :columns="columns" :options="options">

                            <!--  -->
                            <template slot="acciones" slot-scope="zonas">
                                <v-menu bottom right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon v-bind="attrs" v-on="on">
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item  @click="abrir_modal_buscar_empleados_zona_ur(zonas.row)" v-if="zonas.row.asignado ==0 && user.tipo_evaluador =='UR'">
                                            <v-list-item-icon>
                                                <v-icon class="text-success">mdi-arrow-right-bold-box</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>Obtener empleados Zona adscripción</v-list-item-title>
                                        </v-list-item>
 
                                    </v-list>
                                </v-menu>
                            </template>
                            <!--  -->
                            <template slot="asignado" slot-scope="zona">
                                <span v-if="zona.row.asignado ==1" class="text-success">
                                    RESPONSABLE ASIGNADO
                                </span>
                                <span v-else class="text-danger">RESPONSABLE NO ASIGNADO</span>

                            </template>
                        </v-client-table>
                    </v-col>
                    <v-row v-if="showTable" justify="center">
                       
                    </v-row>
                </v-row>
            </v-row>
            <!-- Incluye el componente ModalEspera -->
            <ModalEspera ref="modalEspera"/>
            <!--  -->
              <!-- Modal -->
              <v-dialog v-model="showModal" persistent max-width="900px">
                <v-card>
                    <v-card-title class="headline">{{ titulo_modal }}</v-card-title>
                    <v-card-text>
                        <v-row justify="center">
                            <v-row>
                                <!-- Campo No. Empleado -->
                                <v-col cols="12" sm="3">
                                    <v-text-field
                                    label="No. Empleado"
                                    v-model="no_empleado"
                                    outlined
                                    dense
                                    ></v-text-field>
                                </v-col>

                                <!-- Campo RFC -->
                                <v-col cols="12" sm="3">
                                    <v-text-field
                                    label="RFC"
                                    v-model="rfc"
                                    outlined
                                    dense
                                    ></v-text-field>
                                </v-col>

                                <!-- Campo Nombre Completo -->
                                <v-col cols="12" sm="3">
                                    <v-text-field
                                    label="Nombre Completo"
                                    v-model="nombre_completo"
                                    outlined
                                    dense
                                    ></v-text-field>
                                </v-col>

                                <!-- Botón de Búsqueda -->
                                <v-col cols="12" sm="3">
                                    <v-btn
                                    color="primary"
                                    block
                                    @click="buscar"
                                    >
                                    Buscar
                                    </v-btn>
                                </v-col>
                                </v-row>
                            <v-row v-if="mostrar_tabla_empleados">
                                <v-col   cols="12" sm="12">
                                    <v-client-table :data="dataEmpleados" :columns="columnsEmpleados" :options="optionsEmpleados">

                                        <!--  -->
                                        <template slot="acciones" slot-scope="empleado">
                                            <v-menu bottom right>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-bind="attrs" v-on="on">
                                                        <v-icon>mdi-dots-vertical</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-item  @click="asignar_empleado(empleado.row)">
                                                        <v-list-item-icon>
                                                            <v-icon class="text-success">mdi-arrow-right-bold-box</v-icon>
                                                        </v-list-item-icon>
                                                        <v-list-item-title>Asignar empleado</v-list-item-title>
                                                    </v-list-item>
 
                                                </v-list>
                                            </v-menu>
                                        </template>
                                        <!--  -->
                                        <template slot="asignado" slot-scope="zona">
                                            <span v-if="zona.row.asignado ==1" class="text-success">
                                                ASIGNADO
                                            </span>
                                            <span v-else class="text-danger">NO ASIGNADO</span>

                                        </template>
                                    </v-client-table>
                                </v-col>
                                <v-row v-if="showTable" justify="center">
                                 
                                </v-row>
                            </v-row>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="showModal = false;mostrar_tabla_empleados =false">Cancelar</v-btn>
                        
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!--  -->
    </v-container>
     


</template>
<style>
    .grupo-botones {
      display: none;
      margin-top: 10px;
    }

    .boton {
      padding: 10px 20px;
      margin-right: 5px;
    }

  </style>
<script>
import { mapState } from 'vuex'
import ModalEspera from "./ModalWait.vue";
export default {
    components: {
        ModalEspera,
    },
    data:function(){
        return {
            showTable:false,
            showAlert:false,
            tipos_filtro : [{id:0,descripcion:'TODOS'},{id:1,descripcion:'NO EVALUADOS'},{id:2,descripcion:'GUARDADOS'},{id:3,descripcion:'ENVIADOS'}],
            tipo_filtro : 0,
            // datos tabla
            columns: ['adscripcion', 'asignado','responsable','acciones'],
            options: {
                headings: { 
                    adscripcion       : 'ZONA DE ADSCRIPCIÓN',
                    asignado : 'ESTADO ASIGNACIÓN', 
                    responsable : 'RESPONSABLE',
                    acciones          : 'ACCIONES',

                },
                sortable: ['adscripcion'],
                texts: {
                    count:"Mostrando de {from} a {to} de {count} resultados|{count} resultados|Un resultado",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: true,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 5,
                perPageValues: [5, 10, 15, 20],
                filterable: ['adscripcion'],
                    templates: {

                    }, filterByColumn: true,
            },
            mostrarModal: false,
            //variables
            empleados_a_evaluar    : [],
            liquidados             : [],
            mostrar_tabla_zona : true,
            apellidoPaterno        : '',
            apellidoMaterno        : '',
            nombre                 : '',
            rfc                    : '',
            grupoPuesto            : '',
            datos_evaluador        : [],
            datos_evaluado         : [],
            datos_preguntas        : [],
            grupo_puesto_eval      : '',
            registro_evaluacion    : [],
            editar                 : true,
            dato_cuatrimestre      : false,
            zonas_adscripcion : [],
            id_zona_adscripcion : 0,
            informacion_evaluacion : [],
            dataFechaExtendida : false, 
            existeExcepcionPorcentajeZonaAds : false,
            showModal :false,
            titulo_modal : 'EMPLEADOS ZONA ADSCRIPCIÓN-UR',
            id_ur : null,
            mostrar_tabla_empleados :false,
            dataEmpleados:[],
            columnsEmpleados: ['no_empleado', 'rfc','nombre_completo','asignado','acciones'],
            optionsEmpleados: {
                headings: { 
                    no_empleado       : '# EMPLEADO',
                    rfc : 'RFC', 
                    nombre_completo : 'NOMBRE COMPLETO', 
                    asignado : 'ESTADO ASIGNACIÓN', 
                    acciones          : 'ACCIONES',

                },
                sortable: ['no_empleado', 'rfc','nombre_completo'],
                texts: {
                    count:"Mostrando de {from} a {to} de {count} resultados|{count} resultados|Un resultado",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: true,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 5,
                perPageValues: [5, 10, 15, 20],
                filterable: ['no_empleado', 'rfc','nombre_completo'],
                    templates: {

                    }, filterByColumn: true,
            },
            no_empleado : null,
            rfc : null,
            nombre_completo : null

        }
    },
    computed:{
        ...mapState(["user"]),
        ...mapState(["token"]),
        ...mapState(["baseUrl"])
    },
    async mounted(){
        this.datos_evaluador = JSON.parse(localStorage.getItem('user')); 
        await this.load_datos_cuatrimestre();
        await this.load_zonas_adscripcion();
       
 
        this.$NProgress.done();
    },
    methods:{

        
        
        async load_datos_cuatrimestre(){
            try{
                let response = await this.$http.get("get-datos-cuatrimestre-actual?user_id="+this.user.id_user);

                this.informacion_evaluacion = response.data.data;

            }catch(error){
                this.showAlert = true;
            }
        },

        async load_datos_cuatrimestre(){ 
            try{
                let response = await this.$http.get("get-datos-cuatrimestre-actual?user_id="+this.user.id_user+'&tipo_evaluador='+this.user.tipo_evaluador); 
                this.dato_cuatrimestre                 = response.data.data.datosCuatrimestre; 
                if(this.dato_cuatrimestre){
                    switch (this.dato_cuatrimestre.no_cuatrimestre) {
                    case '1':
                        this.dato_cuatrimestre.no_cuatrimestre = 'ENERO-ABRIL';
                        break;
                    case '2':
                        this.dato_cuatrimestre.no_cuatrimestre = 'MAYO-AGOSTO';
                        break;
                    case '3':
                        this.dato_cuatrimestre.no_cuatrimestre = 'SEPTIEMBRE-DICIEMBRE';
                        break;
                    default:
                        break;
                    }  
                } 
            }catch(error){
                this.showAlert = true;
            }
        },

        abrir_modal_buscar_empleados_zona_ur:function(zonaData){
            this.id_zona_adscripcion = zonaData.id_zona_adscripcion
            this.id_ur = zonaData.id_ur
            this.dataEmpleados = []
            this.no_empleado = null 
            this.rfc= null 
            this.nombre_completo =null
            this.showModal = true;
        },

        async load_zonas_adscripcion(){
            try{ 
                let response = await this.$http.get("get-zona-adscripcion-cuatrimestre-responsable?user_id="+this.user.id_user+'&cuatrimestre_id='+this.dato_cuatrimestre.id+'&tipo_evaluador='+this.user.tipo_evaluador);  
                this.zonas_adscripcion = response.data.data.activos; 
                this.showTable = true;
            }catch(error){
                this.showAlert = true;
            }
        },
        
        async buscar(){
            try{ 
                let response = await this.$http.get("get-empleados-zona-adscripcion-ur?id_zona_adscripcion="+this.id_zona_adscripcion+'&id_ur='+this.id_ur+'&no_empleado='+this.no_empleado+'&rfc='+this.rfc+'&nombre_completo='+this.nombre_completo+'&cuatrimestre_id='+this.dato_cuatrimestre.id); 
                this.dataEmpleados = response.data.data.datos_empleados; 
                this.mostrar_tabla_empleados = true;
            }catch(error){
                this.mostrar_tabla_empleados = true;
            }
        },
        asignar_empleado:async function(data_empleado){

            try{
                var mensaje = '¿DESEA ASIGNAR ESTE EMPLEADO A LA ZONA DE ADSCRIPCIÓN?'
                var mensaje_advertencia = ''
                this.showModal = false;
                this.$swal({
                    className: "text-center",
                    title: mensaje,
                    text: mensaje_advertencia,
                    icon: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    buttons:["Cancelar","Aceptar"],
                    }).then(async (value) => {
                        if(value){
                        
                        let form = new FormData();
                        // form.append("tipo_nomina",this.tipoNomina); 
                        form.append("id_ur",this.id_ur); 
                        form.append("id_user",this.user.id_user);
                        form.append("id_zona_adscripcion",this.id_zona_adscripcion); 
                        form.append("id_empleado",data_empleado.id_empleado); 
                        form.append("nombre_completo",data_empleado.nombre_completo);  
                        form.append("puesto_especifico",data_empleado.puesto_especifico);
                        form.append("cuatrimestre_id",this.dato_cuatrimestre.id); 


                        let response = await this.$http.post("guardar-empleado-zona-adscripcion-ur",form);
                        if(response.data.response){
                            this.$toasted.success('EL EMPLEADO SE HA GUARDADO EXITOSAMENTE!!');
                            
                            this.load_zonas_adscripcion(); 
                            
                        }else{
                            this.showModal = false;
                            this.$swal({
                                title: response.data.error,
                                text: "",
                                icon: "error",
                                button:"Aceptar"
                            }).then(() => this.dialog = true);


                        }
                    }
                });
            }catch(error){
                
                console.log(error)
            }
        },

       
    }
}
</script>
